class QvfCountdown extends HTMLElement {
  connectedCallback() {
    const end = new Date(this.dataset.end).getTime();
    if (isNaN(end)) return;
    this._prev = {};
    this._tick(end);
    this._interval = setInterval(() => this._tick(end), 1000);
  }

  disconnectedCallback() {
    clearInterval(this._interval);
  }

  _tick(end) {
    const diff = Math.max(0, end - Date.now());
    if (diff === 0) clearInterval(this._interval);

    const h = Math.floor(diff / 3600000);
    const m = Math.floor((diff % 3600000) / 60000);
    const s = Math.floor((diff % 60000) / 1000);
    const pad = n => String(n).padStart(2, '0');

    this._update('[data-hours]',   pad(h), 'h');
    this._update('[data-minutes]', pad(m), 'm');
    this._update('[data-seconds]', pad(s), 's');
  }

  _update(selector, value, key) {
    const el = this.querySelector(selector);
    if (!el) return;
    if (this._prev[key] === value) return;
    this._prev[key] = value;
    el.textContent = value;
    el.classList.remove('qvf-countdown__number--flip');
    void el.offsetWidth;
    el.classList.add('qvf-countdown__number--flip');
  }
}

customElements.define('qvf-countdown', QvfCountdown);
